module.exports = __webpack_public_path__ + "static/media/pulsar.9f90fdee.svg";